import React from 'react';
import "../css/GenericPage.css"
import "../css/PremiumOverlay.css"
import {BCIcon, ICONS} from "./generic/BCIcons";
import {FlexCol} from "./generic/Containers";
import {PremiumUpsellModal} from "./PremiumUpsellModal";

export const PremiumOverlay: React.FC<any> = ({user, setShowPremiumOverlay}) => {
    return (
        <div className={'overlay-container'} onClick={() => setShowPremiumOverlay(false)}>
            <FlexCol 
                className="overlay-content premium-overlay-content" 
                onClick={(e) => e.stopPropagation()} 
                maxWidth={80} 
                style={{width: '90vw'}} 
                gap={1} 
                padding={2}
            >
                <BCIcon icon={ICONS.CLOSE} id={'premium-overlay-close-button'} className={'premium-options-close'} onClick={() => setShowPremiumOverlay(false)}/>
                
                <PremiumUpsellModal source="premium_overlay" onSuccess={() => setShowPremiumOverlay(false)}/>
            </FlexCol>
        </div>
    );
};